var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4ExchangeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 694.55 121.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.06,
    y1: 46.93,
    x2: 81.68,
    y2: 46.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#629afd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6d8cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 20.24,
    y1: 74.4,
    x2: 35.79,
    y2: 53.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8770ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8770ff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8770ff",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8770ff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8770ff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 83.39,
    y1: 93.1,
    x2: 10.64,
    y2: 79.93,
    xlinkHref: "#d"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.34,91.26c0-5.3,2.72-9.03,5.45-13.33,6.08-9.61,12.16-19.22,18.24-28.83,3.24-5.11,6.26-10.36,9.51-15.46,2.98-4.68,5.99-10.3,10.81-13.32,6.88-4.32,13.67-.29,19.33,4.11C81.68,5.91,72.28,0,61.2,0c-8.76,0-14.05,3.64-19.83,12.73L6.34,68.08C3.2,73.04.06,77.34.06,83.45c0,7.27,5.45,10.41,16.19,10.41h2.45c-.22-.8-.36-1.64-.36-2.6Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.34,91.26c0-5.3,2.72-9.03,5.45-13.33,6.08-9.61,12.16-19.22,18.24-28.83,3.24-5.11,6.26-10.36,9.51-15.46,2.98-4.68,5.99-10.3,10.81-13.32,6.88-4.32,13.67-.29,19.33,4.11C81.68,5.91,72.28,0,61.2,0c-8.76,0-14.05,3.64-19.83,12.73L6.34,68.08C3.2,73.04.06,77.34.06,83.45c0,7.27,5.45,10.41,16.19,10.41h2.45c-.22-.8-.36-1.64-.36-2.6Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m65.51,70.7c-2.69-.16-5.19-.19-7.84-.17h-27.75s-1.89-.03-1.89-.03c-8.96-.51-13.57-3.66-13.57-10.3,0-2.98.75-5.52,1.88-7.92l-10,15.8c-.43.68-.86,1.35-1.28,2.01h-.06c-2.66,4.16-5,8.08-5,13.36,0,7.27,5.45,10.41,16.2,10.41l41.48-.03s1.66.11,2.56.17c13.97.98,19.28,15.07,21.9,27.55-.02-4.7,0-27.69,0-27.69-1.12-14.33-5.44-20.98-16.62-23.16Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104.14,20.1h55.6v14.43h-39.49v14.95h34.75v14.43h-34.75v15.48h40.01v14.43h-56.13V20.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.69,56.32l-24.64-36.22h18.95l15.37,23.9,15.69-23.9h18.43l-24.64,36.01,25.69,37.7h-18.95l-16.53-25.27-16.64,25.27h-18.43l25.69-37.49Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.03,57.16v-.21c0-20.95,15.79-38.12,38.43-38.12,13.9,0,22.22,4.63,29.06,11.37l-10.32,11.9c-5.69-5.16-11.48-8.32-18.85-8.32-12.43,0-21.38,10.32-21.38,22.96v.21c0,12.64,8.74,23.17,21.38,23.17,8.42,0,13.58-3.37,19.38-8.63l10.32,10.42c-7.58,8.11-16.01,13.16-30.22,13.16-21.69,0-37.8-16.74-37.8-37.91Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.89,20.1h16.22v29.17h29.91v-29.17h16.22v73.71h-16.22v-29.59h-29.91v29.59h-16.22V20.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.09,19.57h14.95l31.59,74.24h-16.95l-6.74-16.53h-31.17l-6.74,16.53h-16.53l31.59-74.24Zm17.06,43.38l-9.79-23.9-9.79,23.9h19.59Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.89,20.1h14.95l34.54,45.38V20.1h16.01v73.71h-13.79l-35.7-46.86v46.86h-16V20.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.71,57.16v-.21c0-20.95,16.32-38.12,38.65-38.12,13.27,0,21.27,3.58,28.96,10.11l-10.21,12.32c-5.69-4.74-10.74-7.48-19.27-7.48-11.79,0-21.17,10.42-21.17,22.96v.21c0,13.48,9.27,23.38,22.32,23.38,5.9,0,11.16-1.47,15.27-4.42v-10.53h-16.32v-14h32.01v32.01c-7.58,6.42-18.01,11.69-31.48,11.69-22.96,0-38.75-16.11-38.75-37.91Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.42,20.1h55.6v14.43h-39.49v14.95h34.75v14.43h-34.75v15.48h40.01v14.43h-56.12V20.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4ExchangeLogo);
export default __webpack_public_path__ + "static/media/4Exchange_logo.37da7f545443cf004193a8c8ee2824ca.svg";
export { ForwardRef as ReactComponent };